import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class SweetAlertService {
  constructor() {}

  sweetSuccess(title: string = '', text: string) {
    Swal.fire({
      title: title,
      text: text,
      icon: 'success',
    });
  }

  sweetError(title: string = '', text: string) {
    Swal.fire({
      title: title,
      text: text || 'Ops! Something went wrong',
      icon: 'error',
    });
  }

  sweetErrors(title: string = '', err: any) {
    let rawError =
      err?.error?.messages ||
      err?.error ||
      err?.messages ||
      err?.message ||
      err ||
      {};

    let message = 'Ops! Something went wrong';

    if (typeof rawError === 'string' && rawError.trim()) {
      message = rawError;
    } else if (Array.isArray(rawError) && rawError.length) {
      message = rawError.join(', ');
    } else if (
      typeof rawError === 'object' &&
      rawError !== null &&
      Object.keys(rawError).length
    ) {
      message = Object.entries(rawError)
        .map(([key, value]) => `${key}: ${value}`)
        .join(',\n');
    }

    Swal.fire({
      title,
      text: message,
      icon: 'error',
    });
  }

  sweetInfo(title: string = '', text: string) {
    Swal.fire({
      title: title,
      text: text,
      icon: 'info',
    });
  }

  sweetOnlyWarning(title: string = '', text: string) {
    return Swal.fire({
      title: title || '',
      text: text || '',
      icon: 'warning',
    });
  }

  async sweetConfirm(
    title: string = '',
    text: string = '',
    icon: 'warning' | 'info' | 'question' = 'warning',
    confirmButtonText: string = 'Yes',
    cancelButtonText: string = 'No',
  ) {
    return await Swal.fire({
      title: title,
      text: text,
      icon: icon,
      iconColor: '#dc2626',
      showCancelButton: true,
      confirmButtonText: confirmButtonText,
      cancelButtonText: cancelButtonText,

      heightAuto: false,
      didOpen: () => {
        document.body.style.overflow = 'hidden';
      },

      didClose: () => {
        document.body.style.overflow = 'auto';
      },

      customClass: {
        popup: '!rounded-2xl !p-6',
        title: '!text-xl !font-semibold !text-black',
        confirmButton:
          '!bg-[#dc2626] !text-white !rounded-3xl !px-5 !py-3 !font-medium !cursor-pointer !w-full !mx-0',
        cancelButton:
          '!bg-transparent !text-dark-gray !rounded-3xl !px-5 !py-3 !w-full !font-medium !cursor-pointer !mx-0 !mt-2',
        actions: '!flex !flex-col !w-full !gap-2 !mt-4',
      },
      buttonsStyling: false,
    });
  }

  async sweetDeleting(
    title: string = 'Delete this package?',
    text: string = 'You won’t be able to revert this!',
    confirmButtonText: string = 'Yes, delete it!',
    cancele: string = 'Skip',
    img: string = '/icons/warning-2.svg',
    backgroundColor: string = '!bg-red',
    cancelButtonClass: string = '',
  ): Promise<boolean> {
    const result = await Swal.fire({
      html: `
      <div style="display:flex;flex-direction:column;align-items:center;gap:16px;border:0">
        <img src="${img}" width="64" height="64" style="border:none;outline:none;" />
         <p style="font-size:24px;color:#0A0E16;margin:0;">${title}</p>
        <p style="font-size:16px;color:#686868;margin:0;">${text}</p>
      </div>
    `,
      showCancelButton: true,
      confirmButtonText: confirmButtonText,
      cancelButtonText: cancele,
      customClass: {
        popup: '!rounded-2xl !p-6',
        title: '!text-xl !font-semibold !text-black',
        confirmButton: `${backgroundColor} !text-white !rounded-3xl !text-sm !px-5 !py-3 !font-bold !cursor-pointer !w-full !mx-0`,
        cancelButton: `${cancelButtonClass} !bg-transparent !text-sm  !text-dark-gray !rounded-3xl !px-5 !py-3 !w-full !font-bold !cursor-pointer !mx-0  !mt-2`,
        actions: '!flex !flex-col !w-full !gap-2 !mt-4',
      },
      buttonsStyling: false,
    });

    return result.isConfirmed;
  }
}
